import { useEffect } from "react";
import { useAuth } from "./useAuth";
import { startBffLogin } from "@/helpers/auth";

interface UseRequireAuthOptions {
  redirectTo?: string;
  requiredRoles?: string[];
}

export const useRequireAuth = (options: UseRequireAuthOptions = {}) => {
  const { requiredRoles = ["super_admin", "admin"] } = options;

  const { isAuthenticated, isLoading, isFetching, user } = useAuth();

  const hasRequiredRole = () => {
    if (requiredRoles.length === 0) return true;
    if (!user) return false;
    return requiredRoles.includes(user.role);
  };

  const hasRole = hasRequiredRole();
  const hasAccess = isAuthenticated && hasRole;

  useEffect(() => {
    if (isFetching) return;

    if (!isAuthenticated) {
      const returnTo =
        typeof window !== "undefined" ? window.location.pathname : "/overview";
      startBffLogin(returnTo);
      return;
    }

    if (!hasRole) {
      window.location.href = "/unauthorized";
    }
  }, [isFetching, isAuthenticated, hasRole]);

  return {
    user,
    hasRole,
    hasAccess,
    isLoading,
    isAuthenticated,
  };
};
